
import axios from "axios";
const customerDetailsApiEndPoint = process.env["REACT_APP_CUSTOMER_DETAIL_END_POINT"]

const api_key = process.env["REACT_APP_API_KEY"];
export const flattenObject = (obj: any) => {
    const flattened: { [key: string]: string | number | boolean | object } = {}
  
  
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(flattened, flattenObject(obj[key]))
      } else {
        flattened[key] = obj[key]
      }
    })
  
    return flattened
  }

export const getEnvVariable = (envVar:any) => {
    const envObj: any = {
      JOURNEY_TYPE: process.env.REACT_APP_JOURNEY_TYPE
              ? process.env.REACT_APP_JOURNEY_TYPE
              : 'HR24APT',
  
    }

    return envObj[envVar] ? envObj[envVar] : undefined
}

export const getJourneyFileName = (userType: any) => {
  const journeyFile: any = {
      Hr24AptLocal: process.env.REACT_APP_JOURNEY_FILE
          ? process.env.REACT_APP_JOURNEY_FILE
          : `Hr24AptLocal`,
      aptLDMiniMovers: process.env.REACT_APP_JOURNEY_FILE
          ? process.env.REACT_APP_JOURNEY_FILE
          : `aptLDMiniMovers`,
      AfterHoursAptLDMiniMovers:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `AfterHoursAptLDMiniMovers`,
      BizHoursLocal:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `BizHoursLocal`,
      AfterHoursLocalMoves:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `AfterHoursLocalMoves`,
      BizHoursLDHomes:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `BizHoursLDHomes`,
      AfterHoursLDMovers:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `AfterHoursLDMovers`,
      MissedAppBizHours:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `MissedAppBizHours`,
      MissedAppAfterHours:process.env.REACT_APP_JOURNEY_FILE
      ? process.env.REACT_APP_JOURNEY_FILE
      : `MissedAppAfterHours`,


  }
  

  return journeyFile[userType] ? journeyFile[userType] : undefined
}

export const generateItemId = () => {
  const randomString =  [...Array(24)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');


  return randomString;
}

export const isObjectEmpty = (objectName:any) => {
  return (
    objectName &&
    Object.keys(objectName).length === 0 &&
    objectName.constructor === Object
  );
};

export const getRandomNumber = () => {
  return new Date().getTime()
}

export const getDayAfterTomorrow = () => {
  const currentDate = new Date();


  let afterTomorrow = new Date(currentDate);
  afterTomorrow.setDate(currentDate.getDate() + 2);

  let dayIndex = afterTomorrow.getDay();

  let daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  let dayNameAfterTomorrow = daysOfWeek[dayIndex];

  return dayNameAfterTomorrow
}

export const getNextThreeMonths = () => {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  const nextThreeMonths = [];

  for (let i = 0; i < 5; i++) {
    const nextMonth = (currentMonth + i) % 12; // Calculate the next month
    const nextYear = currentYear + Math.floor((currentMonth + i) / 12); // Adjust the year if needed

    // Format the month and year as needed
    const formattedMonth = (nextMonth + 1).toString().padStart(2, '0');

    // Get the name of the month for the calculated month
    const monthName = new Date(nextYear, nextMonth, 1).toLocaleString('default', { month: 'long' });

    nextThreeMonths.push({ year: nextYear, month: formattedMonth, monthName });
  }

  return nextThreeMonths;
};
// export const getNextThreeMonths = () => {

//   let months = [];
//   const currentDate = new Date();
//    // Get current month
//    const currentMonth = currentDate.getMonth() + 1; // January is 0, so add 1

//    // Get next two months
//    const nextMonth = (currentMonth % 12) + 1; // Wrap around to January if needed
//    const secondNextMonth = (nextMonth % 12) + 1; // Wrap around to January if needed
 
//    // Assuming you want the month names
//    const monthNames = [
//      'January', 'February', 'March', 'April', 'May', 'June',
//      'July', 'August', 'September', 'October', 'November', 'December'
//    ];
 
//    const currentMonthName = monthNames[currentMonth - 1];
//    const nextMonthName = monthNames[nextMonth - 1];
//    const secondNextMonthName = monthNames[secondNextMonth - 1];

//    months.push({monthName: currentMonthName, month : currentMonth})
//    months.push({monthName: nextMonthName, month:nextMonth})
//    months.push({ monthName :secondNextMonthName, month:secondNextMonth})

//    return months
 
// }

export const getDateFormat = (date:any) => {
  const dateObject = new Date(date);
  const year = dateObject.getFullYear();
  const month = (dateObject.getMonth() + 1).toString().padStart(2, '0'); 
  const day = dateObject.getDate().toString().padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate

}

export const getDateObj = (dates:any) => {
  let dateObj = {};
  dates?.map((item:any,index:any) => {
    let formattedDate = getDateFormat(item?.Date);
    let newDateObj = {[`${formattedDate}`] : {
      "price": item?.Price,
      "color":item?.PriceColor
    }}

    dateObj = {...dateObj, ...newDateObj}

    
  })
  return dateObj;
 
}

export const capitalizeFirstLetter = (str:any) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const appointmentDateFormat = (inputDate:any) => {
    const parts = inputDate.split('/');
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    const dateObject = new Date(year, month - 1, day); // Month is 0-indexed in JavaScript

    const options:any = { month: 'long', day: 'numeric' };
    const formattedDate = dateObject.toLocaleDateString('en-US', options);

    return formattedDate;
}

export const checkVariableInString  = (wordsArray:any, inputString:any) => {

 const lowercasedInputString = inputString.toLowerCase();

 return wordsArray.every((word:any) => lowercasedInputString.includes(word.toLowerCase()));

}

export const createAddress = (addrType:any) => {

  let addr = addrType?.Address1 ? `${addrType?.Address1}, ` : ''
  let city = addrType?.City ? `${addrType?.City}` : '';
  let state = addrType?.State ? `${addrType?.State}` : ''

  if(addrType?.Zip !==""){
    let fullAddr = `${addr} ${city} ${state} ${addrType?.Zip} ,${addrType?.Country}`

    return fullAddr
  }else{
    return ""
  }
 
}

export  const createAdditionalAddr = (addionalAddr:any) => {
  let addrList:any = [];
  addionalAddr?.map((item:any) => {
      let address = createAddress(item);

      addrList.push(address);

  })

  return addrList
}

export const getAdditionalStops = (address:any) => {
  
  let addionalAddresses:any = {};
  if(address?.length > 0){
      address?.map((item:any,index:any) => {
          let key = `additional-stop-${index + 1}`
          let singleAddr = {
              "city": item?.City,
              "state": item?.State,
              "zip": item?.Zip,
              "country": item?.Country,
              "address": item?.Address1,
              "pickupType": item?.PickUp,
              "addresstypeId": item?.AddressType,
              "addressInfoId": item?.AddressInfoID,
              "id": item?.ID,
              "stopOrder": item?.StopOrder
          }

          //let newAddr = { [key] : {...singleAddr}}
          addionalAddresses[`${key}`] = singleAddr
      })
  }
 

  return addionalAddresses
}

export const addItemToInventory = (singleItem:any) => {
  let inventory:any = sessionStorage.getItem("inventory")

  if(inventory){
    inventory = JSON.parse(inventory);

    const remainingItems = inventory.filter((item:any) => item?.itemId !== singleItem?.itemId);

    let newInventory = [...remainingItems];
    newInventory.push(singleItem)

    sessionStorage.setItem('inventory', JSON.stringify(newInventory))
  }
}

export const addItemToSelectedRoom = (roomType:any,roomObj:any) => {
    let selectedRoom = sessionStorage.getItem("selectedRooms")
    if(selectedRoom){
      let newSelectedRoom:any = JSON.parse(selectedRoom)
    
      const isRoomPresent = newSelectedRoom.some((item:any) => item.room === roomObj.room);

      if (!isRoomPresent) {
        newSelectedRoom.push(roomObj);
      }

      sessionStorage.setItem('selectedRooms',JSON.stringify(newSelectedRoom))
    }
}

export const addItemToRooms = (singleItem:any) => {
    let roomInfo:any = sessionStorage.getItem('roomInfo');
    let selectedRoom = sessionStorage?.getItem('selectedRooms');

    if(roomInfo){
      let newRoomInfo = JSON.parse(roomInfo)
      Object.entries(newRoomInfo).forEach(([roomIndex,room]:any) =>{
        Object.entries(room).forEach(([roomType, products]:any) => {
          
          if(products.length >0){
           products.map((item:any) => {
              if(item?.itemId === singleItem?.itemId){   
               

                item['quantity'] = singleItem['quantity']
                let newRoomObj = {
                  room: roomType,
                  index:1,
                  text: roomType,
                  "cubes":singleItem?.cubes,
                  itemId: singleItem?.itemId,
                  
                  
                }
                addItemToSelectedRoom(roomType,newRoomObj)     
                return singleItem

              }
            })
          }
        }) 
      })

     
      sessionStorage.setItem("roomInfo", JSON.stringify(newRoomInfo))
    }

}

export const getLngLtd = async(zipCode:any) => {
        
  return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBNedlUF4iU17OM_agWbH0fy9MXS076ehU&components=postal_code:${zipCode}`)
  .then(function(response){
 

      let longLtd:any = response?.data?.results[0]['geometry']['location']

      return longLtd;
      
  })
  .catch(function(error){
      console.log("Error is ", error)
      return []
  })
}

export const getMobileOperatingSystem = () => {
  let userAgent:any = navigator.userAgent || navigator.vendor || (window as any)?.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
      return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any)?.MSStream) {
      return "iOS";
  }

  return "unknown";
}

export const getSubpath = (url: any) => {
  const pathSegments = new URL(url).pathname.split('/').filter(segment => segment !== '');
  return pathSegments[pathSegments.length - 1];
}

export const convertStringTotalToInt = (total:any) => {
  let stringWithoutDollarSign = total.replace('$', '');
  let stringWithoutComma = stringWithoutDollarSign.replace(',', '');

  let floatValue:any = parseFloat(stringWithoutComma);

  let integerValue = parseInt(floatValue);
  return integerValue
}

export  const getCustomerDetails = async (custToken:any) => {
  let data = {
      "secureToken": custToken
  }
  let response = await axios.post(`${customerDetailsApiEndPoint}`, data, {
      headers: {
          'x-api-key': api_key,

      }
  })

  if (response) {
      let customerDetails = response?.data[0];
      return customerDetails
    
  }



}

export const createCall = async (call_number: any) => {
  //let call = call_number.to
  
  const call = `tel:${call_number}`;
  
  window.open(`${call}`, "_self");
};
export const getStepName = (journeyType:any) => {
  const journeyStep: any = {
    Hr24AptLocal: `AptLocaltxt`,
    AfterHoursLDMovers:`LDhomestxt`,
    AfterHoursLocalMoves: `LocalHometxt`,
    AfterHoursAptLDMiniMovers:`AptLDtxt`,
    aptLDMiniMovers: `aptLDMiniMovers`,
    BizHoursLocal: `BizHoursLocal`,
    BizHoursLDHomes:`BizHoursLDHomes`,
    MissedAppBizHours:`MissedAppBizHours`,
    MissedAppAfterHours:`MissedAppAfterHours`,
  }

  return journeyStep[journeyType] 
}



export const getJourneyName = (journeyType:any) => {
  const journeyName: any = {
    Hr24AptLocal: `AfterHours`,
    AfterHoursLDMovers:`AfterHours`,
    AfterHoursAptLDMiniMovers:`AfterHours`,
    AfterHoursLocalMoves: `AfterHours`,
    Hr24AptLocal_track: `1Hour_OnlineBooker`,
    AfterHoursLDMovers_track:`AfterHours_LDHomes`,
    AfterHoursAptLDMiniMovers_track:`AfterHours_APTLD`,
    AfterHoursLocalMoves_track: `AfterHours_LocalHomes`,
    aptLDMiniMovers: `BizHours`,
    BizHoursLocal: `BizHours`,
    BizHoursLDHomes:`BizHours`,   
    MissedAppBizHours:`BizHours`,
    MissedAppAfterHours:`BizHours`,
  }

  return journeyName[journeyType] 
}

export const clearSessionData = () => {
  sessionStorage.removeItem("roomInfo")
  sessionStorage.removeItem("inventory")
  sessionStorage.removeItem("selectedRooms")
  sessionStorage.removeItem("homeType")
  sessionStorage.removeItem("current_homeBoth")
  sessionStorage.removeItem("current_home")
  sessionStorage.removeItem("new_homeBoth")
  sessionStorage.removeItem("new_home")
  sessionStorage.removeItem("currHomeData")
}